import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import LinkedContentInput from 'components/content/LinkedContentInput';

var LinkedContentField = function LinkedContentField(_ref) {
  var formField = _ref.formField;
  var intl = useIntl();
  var name = formField.name,
      contentTypeNames = formField.contentTypeNames,
      publishedContentOnly = formField.publishedContentOnly,
      labelId = formField.labelId,
      defaultValue = formField.defaultValue;
  var memoizedLinkedContentInput = useMemo(function () {
    return __jsx(LinkedContentInput, {
      name: name,
      contentTypeNames: contentTypeNames,
      publishedContentOnly: publishedContentOnly,
      label: intl.formatMessage({
        id: labelId
      }),
      defaultValue: defaultValue
    });
  }, [intl, name, contentTypeNames, publishedContentOnly, labelId, defaultValue]);
  return memoizedLinkedContentInput;
};

export default LinkedContentField;